import { Box, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import palette from '../../../../shared/lib/theme/palette';
import { flexCenter } from '../../../../shared/lib/theme/styleConstants';
import { useAppContext } from '../../app/contexts/AppContext';
import { TimerProps } from '../../app/interfaceTypes';
import { ActionType } from '../../app/reducer/AppContextReducer';

export const Timer: FC<TimerProps> = ({ infoSteps, title }) => {
  const { timeLeft, dispatch } = useAppContext();

  useEffect(() => {
    if (infoSteps) {
      const timer = setInterval(() => {
        if (timeLeft > 0) {
          dispatch({ type: ActionType.SET_TIME_LEFT, timeLeft: timeLeft - 1 });
        } else {
          dispatch({ type: ActionType.SET_TIME_LEFT, timeLeft: 0 });
        }
      }, 1000);
      return () => clearInterval(timer);
    }
    // eslint-disable-next-line
  }, [timeLeft, infoSteps]);

  const secondsToMinSecPadded = (time: number) => {
    const minutes = `${Math.floor(time / 60)}`.padStart(1, '0');
    const seconds = `${time - parseInt(minutes) * 60}`.padStart(2, '0');
    return `${minutes}m ${seconds}s`;
  };

  const { blackTwo } = palette;
  return (
    <Box sx={flexCenter}>
      <Typography variant="body1" mt="24px" mr={'5px'} sx={{ color: blackTwo }}>
        {title}
      </Typography>
      <Typography variant="body1" mt="24px" sx={{ color: blackTwo }}>
        {timeLeft > 60 ? secondsToMinSecPadded(timeLeft) : `${timeLeft}s`}
      </Typography>
    </Box>
  );
};
